<script setup lang="ts">
import { provideRestaurantOperations } from '../composables/provideRestaurantOperations'

const route = useRoute()

const restaurantSlug = computed(() =>
  typeof route.params.restaurantSlug === 'string'
    ? route.params.restaurantSlug
    : undefined)

provideRestaurantOperations(restaurantSlug)
</script>

<template>
  <slot />
</template>
